import { CommonErrorCode, DatasourceErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { DatasourceContentType } from '../models/ContentTypes';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { IErrorDetail } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';

export class DataSourceErrors {

  public static $inject = ['$translate'];

  constructor(
    private $translate: ng.translate.ITranslateService) { }

  public errorDetailsFor(datasourceErrorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: datasourceErrorItem.item.name,
      itemUrl:
        datasourceErrorItem.error.code === CommonErrorCode.DatasourceNotFound
        || datasourceErrorItem.error.code === CommonErrorCode.DataConnectionNotFound
          ? null
          : ContentUrlForItem(datasourceErrorItem.item, DatasourceContentType),
      errorMessage: this.errorMessageForItem(datasourceErrorItem)
    };
  }

  private errorMessageForItem(errorItem: IErrorItem<IDataSourceBase>) {
    return this.errorMessageFor(errorItem.error, errorItem.item.name);
  }

  public errorMessageFor(error: IError, datasourceName: string = '') {

    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
      case CommonErrorCode.DataConnectionNotFound:
        return this.$translate.instant('errorDatasourceNotFound', {DATASOURCE_NAME: L10n.elideIfLong(datasourceName)});
      case DatasourceErrorCode.DatasourceChangeOwnerDisabled:
        return this.$translate.instant('errorDatasourceChangeOwnerDisabled');

      // Permissions errors
      // TODO: Do we want specific error messages for each of these cases?
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDatasource:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDestinationProject:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnSourceProject:
        return this.$translate.instant('errorDatasourceMoveInsufficientPermissions');
      case DatasourceErrorCode.DatasourceWithSameNameInDestinationProject:
        return this.$translate.instant('errorDatasourceWithSameNameInDestinationProject');
      case CommonErrorCode.CallingUserInsufficientPermissions:
          return this.$translate.instant('errorDatasourceInsufficientPermissions');

      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('DataSourceErrors', DataSourceErrors);
